import React, { Component, ReactNode } from 'react';
import { Avatar } from 'primereact/avatar';
import Icon from '../../icons/Icon';
import { Tag } from 'primereact/tag';
import CustomAnimateButton from '../custom/CustomAnimateButton';
import KeycloakStore from '../../config/KeycloakStore';
import moment from 'moment';
import UserService from '../../service/UserService';
import ServiceContainer from '../../config/ServiceContainer';
import { ServiceNames } from '../../constant/ServiceNames';
import { User } from '../../domain/rbac/RbacDomains';
import LanguageUtil from '../../util/LanguageUtil';

class AccountProfileComponent extends Component<Props> {
  private readonly userService: UserService = ServiceContainer.getInstance().get(ServiceNames.USER);

  public render(): ReactNode {
    const { user } = this.props;
    return (
      <div className={'h-full w-full bg-white rounded-[10px] border border-[#BDBDBD] border-opacity-[0.5]'}>
        <div className={'text-2xl 2xl:text-3xl font-medium mx-[30px] my-[10px] text-f-black-2'}>
          {LanguageUtil.get({ id: 'common.label.profile', defaultMessage: 'Profile' })}
        </div>
        <div className={'bg-[#F6F8FA] h-[calc(100%-50px)] rounded-b-lg flex flex-col items-center px-8 py-8 overflow-y-scroll'}>
          <div className={'grid grid-cols-3 w-full'}>
            <div className={'col-span-1'}>
              <Avatar
                label={this.getAvatarCharacter()}
                className='h-[100px] w-[100px] 2xl:h-[130px] 2xl:w-[130px] rounded-[50%] text-5xl 2xl:text-6xl	bg-gray-500 text-white'
              />
            </div>
            <div className={'col-span-2 2xl:ml-[40px] ml-[20px]'}>
              <span className={'text-2xl 2xl:text-3xl text-f-black-2'}>
                {user.firstName} {user.lastName}
              </span>
              <div className={'mt-[10px]'}>
                <Icon icon={'user-fill'} size={14} />
                <span className={'text:md 2xl:text-lg text-f-black-3'}>{user.username}</span>
              </div>
              <div className={'mt-[10px]'}>
                <Icon icon={'envelope'} size={14} />
                <span className={'text:md 2xl:text-lg text-f-black-3'}>{user.email}</span>
              </div>
              <CustomAnimateButton
                className={'mt-[20px] ml-0'}
                onClick={this.logOut}
                icon={<Icon icon={'logout2'} size={20} className={'m-[10px]'} />}
                customType={'logout'}
                text={LanguageUtil.get({ id: 'common.button.logout', defaultMessage: 'Logout' })}
              />
            </div>
          </div>
          <hr className={'mt-[20px] mb-[20px] w-full'} />
          <div className={'h-1/4 w-full'}>
            <span className={'text-2xl 2xl:text-3xl text-f-black-2'}>{LanguageUtil.get({ id: 'common.label.roles', defaultMessage: 'Roles' })}</span>
            <div className={'2xl:mt-[20px] mt-[16px]'}>
              {user.roles.map((role: string) => {
                return <Tag className='mr-2 bg-[#728EFF]' value={role} icon='pi pi-user' key={role} />;
              })}
            </div>
          </div>
          <div className={'h-1/4 w-full'}>
            <span className={'text-2xl 2xl:text-3xl text-f-black-2'}>{LanguageUtil.get({ id: 'common.label.groups', defaultMessage: 'Groups' })}</span>
            <div className={'2xl:mt-[20px] mt-[16px]'}>
              {user.groups.map((group: string) => {
                return <Tag className='mr-2 bg-primary' value={group} icon='pi pi-users' key={group} />;
              })}
            </div>
          </div>
          <hr className={'2xl:mt-[10px] mt-[0px] mb-[10px] w-11/12'} />
          <div className={'text-center mr-[40px]'}>
            <span className={'block text-2xl 2xl:text-3xl text-[#4F4F4F]'}>
              {user.lastLoginDate == undefined ? 'None' : moment(user.lastLoginDate ?? 0).format('yyyy-MM-DD HH:mm:ss')}
            </span>
            <span className={'2xl:text-lg text-md text-[#4F4F4F]'}>
              {LanguageUtil.get({ id: 'common.label.lastOnlineDate', defaultMessage: 'Last Online Date' })}
            </span>
          </div>
        </div>
      </div>
    );
  }

  private getAvatarCharacter = (): string => {
    const { user } = this.props;
    const { firstName, lastName } = user;
    return firstName?.[0] + lastName?.[0] || '';
  };

  private logOut = async () => {
    await this.userService.logout();
    localStorage.removeItem('state');
    localStorage.removeItem('react-refresh-token');
    localStorage.removeItem('sub');
    localStorage.removeItem('react-token');
    KeycloakStore.getKeycloakInstance()?.logout();
  };
}

interface Props {
  user: User;
}

export default AccountProfileComponent;
